class FocusTrap extends HTMLElement {
  constructor() {
    super();
    this.handleTab = this.handleTab.bind(this);
  }

  initElements() {
    this.focusableElements = this.getFocusableElements();
  }

  connectedCallback() {
    this.setAttribute('tabindex', '-1');
    this.initElements();
  }

  disconnectedCallback() {
    this.removeEventListener('keydown', this.handleTab);
  }

  update() {
    this.initElements();
  }

  isHidden(element) {
    return (
      element.getAttribute('tabindex') === '-1' ||
      element.hasAttribute('hidden') ||
      element.hasAttribute('disabled') ||
      (element.hasAttribute('aria-hidden') &&
        element.getAttribute('aria-hidden') !== 'false') ||
      element.style.display === `none` ||
      element.style.opacity === `0`
    )
  }

  getFocusableElements() {
    const selectors = [
      'a[href]', 'area[href]', 'input:not([disabled])', 'select:not([disabled])',
      'textarea:not([disabled])', 'button:not([disabled])', 'iframe', 'object',
      'embed', '[tabindex]:not(sl-radio)', '[contenteditable]'
    ];
    return Array.from(this.querySelectorAll(selectors.join(',')))
      .filter(el => {
        return !this.isHidden(el)
      });
  }

  handleTab(e) {
    if (e.key !== 'Tab') return;
    this.focusableElements = this.getFocusableElements();
    if (!this.focusableElements.length) {
      e.preventDefault();
      return;
    }
    const first = this.focusableElements[0];
    const last = this.focusableElements[this.focusableElements.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'active') {
      if (this.hasAttribute('active')) {
        this.initElements();
        this.addEventListener('keydown', this.handleTab);
      } else {
        this.focusableElements = [];
        this.removeEventListener('keydown', this.handleTab);
      }
    }
  }

  static get observedAttributes() {
    return ['active'];
  }
}

if (!customElements.get('focus-trap')) {
  customElements.define('focus-trap', FocusTrap);
}
